/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CancelOrderByIdOptions, CancelOrderByIdResponses } from '../types/CancelOrderById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Cancel an order by ID
 * {@link /v1/orders/:order_id}
 */
export function cancelOrderById<ThrowOnError extends boolean = true>(
  options: Options<CancelOrderByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<CancelOrderByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'DELETE',
      url: '/v1/orders/{order_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CancelOrderByIdResponses, ThrowOnError>>,
  )
}
